import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../ChangePassword/ChangePassword.css";

const ChangePassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await fetch("https://api.hgcdental.clinic/api/profile", {
                    method: "GET",
                    credentials: "include", // Needed if using cookies for auth
                    headers: { 
                        "Content-Type": "application/json",
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setEmail(data.email);
                } else {
                    throw new Error("Failed to fetch profile");
                }
            } catch (error) {
                setMessage("Failed to load user profile. Please try again.");
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfile();
    }, []);

    const handleForgotPassword = async (event) => {
        event.preventDefault();

        try {
            const response = await fetch("https://api.hgcdental.clinic/forgot-password", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            setMessage(data.message);

            if (response.ok) {
                navigate("/verify-otp", { state: { email } });
            }
        } catch (error) {
            setMessage("Error sending OTP. Please try again.");
        }
    };

    if (isLoading) {
        return <div className="changepassword-container">Loading...</div>;
    }

    return (
        <div className="changepassword-container">
            <div className="changepassword-content">
                <div className="signup-card-2">
                    <h2>Change Password</h2>
                    <p>Click the "Send OTP" button to receive a password reset OTP.</p>

                    <form onSubmit={handleForgotPassword}>
                        <input
                            type="email"
                            value={email}
                            disabled
                            required
                        />
                        <button type="submit">Send OTP</button>
                    </form>
                    
                    {message && <p className="message">{message}</p>}

                    {/* Cancel Button */}
                    <button className="cancel-button" onClick={() => navigate(-1)}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;
